import {
  ElementDimensions,
  PositionCoords,
  PositionOption,
  PositionStrategy,
  PositionStrategyResult
} from "./position-strategy";

export class WindowPositionStrategy extends PositionStrategy {
  constructor(
    private overlayPosition: PositionOption,
    private windowPadding: number = 20
  ) {
    super();
  }

  getPosition(
    clientRect: ClientRect,
    windowRef: Window
  ): PositionStrategyResult {
    let windowSize: ElementDimensions = this.getWindowDimensions(windowRef),
      coords: PositionCoords;

    switch (this.overlayPosition) {
      case "top-right":
        coords = {
          top: this.windowPadding,
          right: this.windowPadding
        };
        break;
      case "bottom-right":
        coords = {
          bottom: this.windowPadding,
          right: this.windowPadding
        };
        break;
      case "top-left":
        coords = {
          top: this.windowPadding,
          left: this.windowPadding
        };
        break;
      case "bottom-left":
        coords = {
          bottom: this.windowPadding,
          left: this.windowPadding
        };
        break;
      case "top":
        coords = {
          top: this.windowPadding,
          left: windowSize.width / 2 - clientRect.width / 2
        };
        break;
      case "bottom":
        coords = {
          bottom: this.windowPadding,
          left: windowSize.width / 2 - clientRect.width / 2
        };
        break;
      case "right":
        coords = {
          right: this.windowPadding,
          top: windowSize.height / 2 - clientRect.height / 2
        };
        break;
      case "left":
        coords = {
          left: this.windowPadding,
          top: windowSize.height / 2 - clientRect.height / 2
        };
        break;
      case "center":
      case "dead-center":
        coords = {
          left: windowSize.width / 2 - clientRect.width / 2,
          top: windowSize.height / 2 - clientRect.height / 2
        };
        break;
      default:
        throw new Error("Invalid position strategy: " + this.overlayPosition);
    }

    return {
      coords,
      position: this.overlayPosition
    };
  }
}
